
import { Prop, Watch } from 'vue-property-decorator'
import { Vue, Options } from 'vue-class-component'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import LoadingButton from '../loading-button/loading-button.vue'
import QSelect from 'quasar/src/components/select/QSelect.js';import QInput from 'quasar/src/components/input/QInput.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QForm from 'quasar/src/components/form/QForm.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import CustomerProfiles from '@/interfaces/customer-profiles'
import AddressList, { AddressDistricts, AddressSubDistricts } from '@/interfaces/address-list'
import { isNullOrEmpty, isValidEmail } from  '@/utils/validator'
import { getLocalFromInterPhone } from '@/helpers/formatter'
import * as addressService from '@/services/line-web-loyalty-bff/v1/address'
import * as meService from '@/services/line-web-loyalty-bff/v1/me'
import { useStore } from '@/store'
import { getLocalStorage } from '@/helpers/cacheStorage'
import { KeyCache } from '@/model/key-cache.model'
import LoadingSpinner from '../loading-spinner/loading-spinner.vue'
import AlertMessage from '../alert-message/alert-message.vue'
import { alertMessageOptionsOtherCaseError } from '@/model/alert-options.model'
import { modalOptionsConfirmationEditProfile, modalOptionsExceededRateLimit, modalOptionsSubmitError, modalOptionsSubmitSucceed } from '@/model/modal-options.model'
import ModalEditMobilePage from '../modal-edit-mobile-page/modal-edit-mobile-page.vue'
import ModalBottomNotificationOptions from '@/interfaces/modal-bottom-notification-options'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import { hashData } from '@/utils/hash-data'
import EventCodeConfigs from '@/interfaces/event-code-configs'

library.add(faChevronLeft)

@Options({
  components: {
    FontAwesomeIcon,
    LoadingButton,
    QSelect,
    QInput,
    QIcon,
    QForm,
    QBtn,
    QItem,
    QItemSection,
    QSkeleton,
    LoadingSpinner,
    AlertMessage,
    ModalEditMobilePage,
  },
  computed: {
    lineInfo() {
      return this.$store.state.lineInfo
    },
    isLoadingSpinner() {
      return this.$store.state.modalEditProfile.isLoadingSpinner
    },
    isAlertMessageActive() {
      return this.$store.state.alertMessage.isAlertMessageActive
    },
    isModalClose() {
      return this.$store.state.modalEditProfile.isModalClose
    },
    isModalEditMobilePageActive() {
      return this.$store.state.modalEditMobile.isModalActive
    },
    isEnabledEditMobileNumber () {
      const config: EventCodeConfigs | undefined = this.store.state.modalBanner.eventCodeConfigs.find((item: EventCodeConfigs) => item.event_code === 'edit_profile')
      return config?.is_enabled_edit_mobile_number?? false
    }
  }
})
export default class ModalEditProfilePage extends Vue {
  @Prop() openModalUnlinkConfirmation!: () => void
  @Prop() onSubmit!: (form: CustomerProfiles) => void
  
  store = useStore()
  private isTooltipDateOfBirth = false
  private isTooltipNationalID = false
  private isSubmit = false
  private isSkeleton = true

  private textTooltip = 'เพื่อความปลอดภัยและความเป็นส่วนตัวของคุณ ข้อมูลนี้ไม่สามารถแก้ไขได้ กรุณาติดต่อคอลเซ็นเตอร์'
  private textNoResults = 'No results'
  private genderOptions = [ { label: 'ชาย', value: 'Male' },{ label: 'หญิง', value: 'Female' },{ label: 'ไม่ระบุ', value: 'None'} ]
  private customerProfileInfo: CustomerProfiles = {}
  private addressList: AddressList[] = []
  private provinceOptions: AddressList[] = []
  private districtList: AddressDistricts[] = []
  private districtOptions: AddressDistricts[] = this.districtList
  private subDistrictList: AddressSubDistricts[] = []
  private subDistrictOptions: AddressSubDistricts[] = this.subDistrictList
  private updateProfiles: CustomerProfiles = {}
  private model: CustomerProfiles = {
    first_name: '',
    last_name: '',
    gender: '',
    date_of_birth: '',
    national_id: '',
    phone_number: '',
    email: '',
    address: {
      address_number: '',
      th_moo: '',
      th_soi: '',
      th_road: '',
      th_province: '',
      th_district: '',
      th_sub_district: '',
      postal_code: ''
    }
  }
  private isEnabledEditMobileNumber?: boolean

  @Watch('isEnabledEditMobileNumber')
  onUpdatedPoints(newValue: any) {
    this.isEnabledEditMobileNumber = newValue
  }

  async created() {
    await this.getEventCodeConfigsData()
    const localStorageInfo = getLocalStorage(KeyCache.INFO)
    const token = this.store.state.lineInfo.idToken || localStorageInfo?.lineInfo?.idToken as string
    if (!token) {
      await this.waitForLineIdToken()
    }
    await this.getCustomerProfileInfo(token)
    this.bindDataToModel()
    this.isSkeleton = false
    await this.getAddress(token)
    this.bindDataToAddress()
  }

  async getEventCodeConfigsData() {
    await this.store.dispatch('modalBanner/fetchEventCodeConfigsList')
  }
  
  async waitForLineIdToken() {
    let isLooping = true
    while (isLooping) {
      if (this.store.state.lineInfo.idToken) {
        isLooping = false
        break
      }
      await this.sleep(10)
    }
  }

  sleep(ms: number) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, ms)
    })
  }

  async getCustomerProfileInfo(token: string) {
    if (token) {
      const result = await meService.getCustomerInfo(token, ['profile'])
      const statusCode = result.httpStatusCode
      if (statusCode === 200) {
        const items = result.json.data?.profile
        this.customerProfileInfo = {
          first_name: items?.firstName,
          last_name: items?.lastName,
          gender: items?.gender,
          date_of_birth: items?.dateOfBirth,
          national_id: items?.nationalId,
          phone_number: items?.mobileNumber,
          email: items?.email,
          address: {
            address_number: items?.address?.addressNumber,
            th_moo: items?.address?.thMoo,
            th_soi: items?.address?.thSoi,
            th_road: items?.address?.thRoad,
            th_province: items?.address?.thProvince,
            th_district: items?.address?.thDistrict,
            th_sub_district: items?.address?.thSubDistrict,
            postal_code: items?.address?.postalCode
          }
        }
      } else {
        throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }
    }
  }

  async getAddress(token: string) {
    if (token) {
      const result = await addressService.getAddressList(token)
      const statusCode = result.httpStatusCode
      if (statusCode === 200) {
        this.addressList = result.json.data
      } else {
        throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }
    }
  }

  bindDataToModel() {
    const keys = Object.keys(this.customerProfileInfo)
    if (keys.length) {
      keys.forEach((key) => {
        // Lite (online) members have no profile data, JSON.stringify(undefined) would make JSON.parse throw
        if (this.customerProfileInfo[key] === undefined) {
          return
        }
        const value = JSON.parse(JSON.stringify(this.customerProfileInfo[key]))
        if (key === 'date_of_birth') {
          this.model[key] = this.generateDateOfBirth(value)
        } else if (key === 'phone_number') {
          this.model[key] = getLocalFromInterPhone(value)
        } else {
          this.model[key] = value
        }
      })
    }
  }

  bindDataToAddress() {
    this.provinceOptions = this.addressList
    const value = this.model.address
    if (value) {
      const province = value.th_province && this.addressList.length ? this.filterAddress(value.th_province, this.addressList) : []
      this.districtList = province.length ? province[0].districts : []

      const district = value.th_district && this.districtList.length ? this.filterAddress(value.th_district, this.districtList) : []
      this.subDistrictList = district.length ? district[0].subdistricts : []
    }
  }

  async submitForm() {
    this.isSubmit = true
    this.areObjectsEqual(this.customerProfileInfo, this.model)
    setTimeout(() => {
      this.updateCustomerProfiles(this.updateProfiles)
    }, 100)

    this.updateGAEvent('mylotuss_profile_save')
  }

  async updateCustomerProfiles(form: CustomerProfiles) {
    let modalOptionsNotification: ModalBottomNotificationOptions
    const token = this.store.state.lineInfo.idToken
    if (token) {
      const result = await meService.updateCustomerProfiles(token, form)
      const statusCode = result.httpStatusCode
      if (statusCode === 200) {
        modalOptionsNotification = modalOptionsSubmitSucceed(this.store)
      } else {
        modalOptionsNotification = modalOptionsSubmitError(this.store)
      }
      this.store.dispatch('modalNotification/onOpen', modalOptionsNotification)
    }
  }

  generateDateOfBirth(date: string) {
    let result = ''
    const dateOfBirth = date ? date.split(/-| /) : undefined
    if (dateOfBirth) {
      const strDay = dateOfBirth[2]
      const strMonth = dateOfBirth[1]
      const strYear = parseInt(dateOfBirth[0]) + 543
      result = `${strDay}/${strMonth}/${strYear}`
    }
    return result
  }

  onShowTooltipDateOfBirth() {
    this.isTooltipDateOfBirth = !this.isTooltipDateOfBirth
    this.isTooltipNationalID = false
  }

  onShowTooltipNationalID() {
    this.isTooltipDateOfBirth = false
    this.isTooltipNationalID = !this.isTooltipNationalID
  }

  setFocusOnElement(element: any) {
    if (element) {
      setTimeout(() => {
        element.focus()
        element.scrollIntoView()
      }, 20)
    }
  }

  onValidationError(ref: any) {
    const keys = [ 'first_nameInput', 'last_nameInput', 'emailInput', 'address_numberInput', 'address_provinceInput', 'address_districtInput', 'address_sub_districtInput', 'address_postal_codeInput' ]
    for (let key of keys) {
      if (ref[key].hasError) {
        this.setFocusOnElement(ref[key].$el)
        break
      }
    }
  }

  checkFormatEmail(val: string) { 
    return isValidEmail(val) 
  }

  filterAddress(val: string, lists: any[]) {
    return val ? lists.filter(v => v.name_th.toLowerCase().indexOf(val.toLowerCase()) > -1) : []
  }

  filterProvince(val: string, update: any) {
    if (isNullOrEmpty(val) || val === undefined) {
      return update(() => { this.provinceOptions = this.addressList })
    }
    update(() => { this.provinceOptions = this.filterAddress(val, this.addressList) })
  }

  onChangeProvince(val: any) {
    const filtered = this.filterAddress(val, this.addressList)
    this.districtList = filtered.length ? filtered[0].districts : []
    let modelAddress = this.model.address
    if (modelAddress) {
      modelAddress.th_district = undefined
      modelAddress.th_sub_district = undefined
      modelAddress.postal_code = undefined
    }
    this.subDistrictList = []
  }

  filterDistrict(val: string, update: any) {
    if (isNullOrEmpty(val) || val === undefined) {
      return update(() => { this.districtOptions = this.districtList })
    }
    update(() => { this.districtOptions = this.filterAddress(val, this.districtList) })
  }

  onChangeDistrict(val: any) {
    const filtered = this.filterAddress(val, this.districtList)
    this.subDistrictList = filtered.length ? filtered[0].subdistricts : []
    let modelAddress = this.model.address
    if (modelAddress) {
      modelAddress.th_sub_district = undefined
      modelAddress.postal_code = undefined
    }
  }

  filterSubDistrict(val: string, update: any) {
    if (isNullOrEmpty(val) || val === undefined) {
      return update(() => { this.subDistrictOptions = this.subDistrictList })
    }
    update(() => { this.subDistrictOptions = this.filterAddress(val, this.subDistrictList) })
  }

  onChangeSubDistrict(val: any) {
    let modelAddress = this.model.address
    if (modelAddress) {
      const filtered = this.filterAddress(val, this.subDistrictList)
      modelAddress.postal_code = filtered.length ? filtered[0].postcode : ''
    }
  }

  onChangePostalCode(val: any) {
    let modelAddress = this.model.address
    if (modelAddress) {
      const result = val ? val.replace(/\D/g,'') : ''
      modelAddress.postal_code = result
    }
  }

  openModalUnlinkWhenIsNotSubmitting() {
    if (this.isSubmit) return
    this.openModalUnlinkConfirmation()
  }

  areObjectsEqual(oldObject: CustomerProfiles, newObject: CustomerProfiles): boolean {
    const oldKeys = Object.keys(oldObject)
    const newKeys = Object.keys(newObject)
  
    if (!this.isSubmit && (oldKeys.length !== newKeys.length)) {
      return false
    }

    if (oldKeys.length) {
      for (const key of oldKeys) {
        const valueOld = oldObject[key] ? oldObject[key] : ''
        let valueNew = newObject[key] ? newObject[key] : ''
        const readOnlyKeys = ['date_of_birth', 'national_id', 'phone_number']
        if (readOnlyKeys.includes(key)) continue
        if (key === 'address') {
          let updateAddress: any = {}
          const addressKeys = Object.keys(valueNew)
          if (addressKeys.length) {
            for (const addressKey of addressKeys) {
              const addressNew = valueNew[addressKey] ? valueNew[addressKey] : ''
              const addressOld = valueOld[addressKey] ? valueOld[addressKey] : ''
              if (addressNew !== addressOld) {
                if (!this.isSubmit) return false
                updateAddress[addressKey] = addressNew
              }
            }
          }
          if (this.isSubmit && (Object.keys(updateAddress).length > 0)) {
            this.updateProfiles[key] = updateAddress
          }
        } else {
          if (valueNew !== valueOld) {
            if (!this.isSubmit) return false
            if (key === 'gender' && !valueNew) valueNew = 'None'
            this.updateProfiles[key] = valueNew
          }
        }
      }
    }

    return true
  }

  closeModal() {
    this.store.dispatch('alertMessage/onClose')
    if (this.isSubmit) return
    if (this.areObjectsEqual(this.customerProfileInfo, this.model) || this.isSkeleton) {
      this.store.dispatch('modalEditProfile/onClose')
    } else {
      this.store.dispatch('modalNotification/onOpen', modalOptionsConfirmationEditProfile(this.store))
    }
  }

  async editMobileNumber() {
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', true)
    const token = this.store.state.lineInfo.idToken
    if (token) {
      const result = await meService.getQuotaUpdateMobileNumber(token, 'UpdateMobileNumber')
      const statusCode = result?.json?.code
      if (statusCode === 200) {
        this.store.dispatch('modalEditMobile/onResetStep')
        this.store.dispatch('modalEditMobile/onOpen')
      } else if (statusCode === 429) {
        this.store.dispatch('modalNotification/onOpen', modalOptionsExceededRateLimit(this.store))
      } else {
        this.store.dispatch('alertMessage/onOpen', alertMessageOptionsOtherCaseError)
        setTimeout(() => this.store.dispatch('alertMessage/onClose'), 3000)
      }
    }
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)

    this.updateGAEvent('mylotuss_profile_edit_phone')
  }

  async updateCustomerInfo() {
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', true)
    const localStorageInfo = getLocalStorage(KeyCache.INFO)
    const token =
      this.store.state.lineInfo.idToken || (localStorageInfo?.lineInfo?.idToken as string)
    await this.getCustomerProfileInfo(token)
    this.bindDataToModel()
    this.isSkeleton = false
    await this.getAddress(token)
    this.bindDataToAddress()
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
  }

  updateGAEvent(txtEvent: string) {
    const userId = this.store.state.lineInfo?.profile?.userId
    const customerType = this.store.state.customer?.customerType
    addGAEvent({
      event: txtEvent,
      scope: customerType,
      loyalty_Info_complete: userId || customerType ? true : false,
      customer_type: customerType,
      phone_hash: hashData(this.store.state.customer?.phoneNumber as string),
      surrogate_id: userId
    })
  }
}
